import LogRocket from 'logrocket';
import setupLogRocketReact from 'logrocket-react';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import logToConsole from '../../Utils/logToConsole';

const LogRocketSession = () => {
  const { iFrameId } = useSelector((store) => store.optionalFormConfig);
  const { pageUrl } = useSelector((store) => store.formConfig);
  const { logRocketClientId, isSessionRecordingRequired } = useSelector(
    (store) => store.logRocket
  );
  const [sessionTrackerInitialised, setSessionTrackerInitialised] =
    useState(false);

  const initialiseLogRocketSessionTracker = async () => {
    const parentPageUrlObject = new URL(pageUrl);
    const parentDomain = parentPageUrlObject.origin;
    if (!sessionTrackerInitialised) {
      LogRocket.init(logRocketClientId, {
        mergeIframes: true,
        parentDomain,
        dom: {
          inputSanitizer: true,
        },
      });
      await setupLogRocketReact(LogRocket);
      await LogRocket.identify(iFrameId, { parentPage: pageUrl });
      setSessionTrackerInitialised(true);
      logToConsole.info(
        'MVF EMBED INFO - LogRocket Session Recording is enabled on Chameleon'
      );
    }
  };

  useEffect(() => {
    if (
      pageUrl &&
      iFrameId &&
      typeof logRocketClientId === 'string' &&
      isSessionRecordingRequired === true
    ) {
      initialiseLogRocketSessionTracker();
    }
  }, [pageUrl, iFrameId, isSessionRecordingRequired]);

  return null;
};

export default LogRocketSession;
